import Input from "@dangerfarms/ui-system/Input";
import styled from "styled-components";

const TextArea = styled(Input).attrs(() => ({ as: "textarea" }))`
  resize: none;
`;

export default TextArea;
